export default {
  path: '/dashboard',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'publishHistory',
      name: 'publishHistory',
      component: () => import('@/pages/homepage/publishHistory.vue'),
      meta: {
        keepAlive: true,
        title: '物产云发布历史',
      },
    },
    {
      path: 'overdueReminderPage',
      name: 'overdueReminderPage',
      component: () => import('@/pages/homepage/overdueReminder/index.vue'),
      meta: {
        keepAlive: true,
        title: '逾期提醒',
      },
    },
  ],
};
